// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "timeInRoute-7jttr";
var _3 = "flightNumber-4JDCW";
export { _1 as "__esModule", _2 as "timeInRoute", _3 as "flightNumber" }
export default { "__esModule": _1, "timeInRoute": _2, "flightNumber": _3 }
